import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  getTotalMappingsCount,
  getTotalApplicationsCount,
  getSubmissionsCount,
} from 'wisestep-api';

import { defaultHits } from '../../types';
import CountWithTextCard from '../countWithTextCard';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const JobCRMCountsChart = ({ payload }: IPayloadDTOJobsCrm) => {
  const [hits, setHits] = useState({
    totalMappingsCount: defaultHits,
    totalApplicationsCount: defaultHits,
    submissionsCount: defaultHits,
  });
  useEffect(() => {
    const fetchData = async () => {
      const getTotalMappingsCountResponse = await getTotalMappingsCount(payload);
      const getTotalApplicationsCountResponse = await getTotalApplicationsCount(payload);
      const getSubmissionsCountResponse = await getSubmissionsCount(payload);

      setHits({
        totalMappingsCount: getTotalMappingsCountResponse.data.hits,
        totalApplicationsCount: getTotalApplicationsCountResponse.data.hits,
        submissionsCount: getSubmissionsCountResponse.data.hits,
      });
    };
    fetchData();
  }, [payload]);
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={4}>
        <CountWithTextCard count={hits.totalMappingsCount.total} text="Total Mappings" />
      </Grid>
      <Grid item xs={4}>
        <CountWithTextCard count={hits.submissionsCount?.total} text="Total Submissions" />
      </Grid>
      <Grid item xs={4}>
        <CountWithTextCard count={hits.totalApplicationsCount?.total} text="Total Applications" />
      </Grid>
    </Grid>
  );
};
export default JobCRMCountsChart;
